import type { HallowQueries } from "../types";
import { appendQueries } from "./appendQueries";

export const openAppDownloads = async () => {
  window.location.href = `https://hallow.com/downloads`;
};

export const openAppFavorites = async () => {
  window.location.href = `https://hallow.com/favorites`;
};

export const redirectToAuth = async (queries: HallowQueries = {}) => {
  const target = new URL(
    `/login?redirect=${encodeURIComponent(window.location.href)}${appendQueries(queries)}`,
    window.location.href,
  );
  window.location.href = target.toString();
};

export const openEmail = ({
  email,
  subject = "",
  body = "",
}: {
  email: string;
  subject?: string;
  body?: string;
}) => {
  const mailtoLink = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(mailtoLink, "_blank");
};
